import { useState, useEffect, useRef } from "react";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";

const COMMON_ROLES = [
  "Frontend Developer",
  "Backend Developer",
  "Fullstack Developer",
  "Mobile App Developer",
  "UI/UX Designer",
  "Product Manager",
  "Data Scientist",
  "DevOps Engineer",
  "QA Engineer",
  "Machine Learning Engineer",
  "Project Manager",
  "Cloud Architect",
  "Cybersecurity Analyst",
  "project Manager"
];

export default function NewRole() {
  const { userStack, updateUserStack, updateUserLanguages, updateUserFrameworks } = useClientSignUpSteps();
  const [localValue, setLocalValue] = useState(userStack === "other" ? "" : (userStack || ""));
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setLocalValue(value);
    
    if (value.trim()) {
      updateUserStack(value.trim());
    } else {
      updateUserStack('other');
    }

    if (value.trim()) {
      const filtered = COMMON_ROLES.filter((role) =>
        role.toLowerCase().includes(value.toLowerCase()) && 
        role.toLowerCase() !== value.toLowerCase()
      );
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSelectSuggestion = (role) => {
    setLocalValue(role);
    setShowSuggestions(false);
    updateUserStack(role);
    updateUserLanguages([]);
    updateUserFrameworks([]);
  };

  const handleConfirmOther = () => {
    if (localValue.trim()) {
      updateUserStack(localValue.trim());
      updateUserLanguages([]);
      updateUserFrameworks([]);
      setShowSuggestions(false);
    }
  };

  return (

     <div className="flex flex-col gap-4">
    
              <div className="flex w-full items-center gap-4">
                <p className="text-semibold">Select Role</p>
              </div>

    <div ref={containerRef} className="mt-2 animate-in fade-in slide-in-from-top-1 duration-300 relative">
      <div className="relative">
        <input
          type="text"
          placeholder="Type your role and press Enter"
          className="w-full p-3 rounded-xl border-2 border-primary/20 focus:border-primary outline-none transition-all bg-white shadow-sm"
          value={localValue}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleConfirmOther();
            }
          }}
          onFocus={() => {
            if (localValue.trim() && suggestions.length > 0) {
              setShowSuggestions(true);
            }
          }}
        />

        {/* Suggestions Dropdown */}
        {showSuggestions && suggestions.length > 0 && (
          <div className="absolute z-50 w-full mt-2 bg-white border border-gray-100 rounded-xl shadow-xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            <div className="max-h-60 overflow-y-auto">
              {suggestions.map((role, index) => (
                <button
                  key={index}
                  onClick={() => handleSelectSuggestion(role)}
                  className="w-full text-left px-4 py-3 text-sm hover:bg-primary/5 transition-colors border-b border-gray-50 last:border-0 group flex items-center justify-between"
                >
                  <span className="font-medium text-gray-700 group-hover:text-primary">{role}</span>
                  <span className="text-[10px] text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity">Select</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      <p className="text-xs text-muted-foreground mt-1 ml-1 font-medium">
        Can't find the role you're looking for? Type it above and press{" "}
        <span className="text-primary font-bold">Enter</span> to proceed.
      </p>
    </div>

    </div>
  );
}